export const LOCATION_CONSTRAINTS = {
    name: { maxLength: 30, label: 'Location name' },
    description: { maxLength: 252, label: 'Description' },
    locationGroupId: { label: 'Warehouse' },
};
//# sourceMappingURL=constraints.js.map